<template>
	<a
		class="btn btn-secondary d-flex align-items-center"
		@click="goToPreviousUrl()">
		<i class="fa fa-reply"></i>
		Voltar
	</a>
</template>

<script setup lang="ts">
	function goToPreviousUrl() {
		window.history.back();
	}
</script>
